<template>
  <div
    v-if="$store.state.autofillDetails !== null && $store.state.officialModels !== null"
    id="editorQuestionnaireView"
  >

    <editor-view class="col-6 master border"/>
    <questionnaire-view class="col-6 master2" />

  </div>

  <div style="left: 50%;position: absolute;top: 25%;" v-else>
    <f-spinner/>
    <span>Loading ...</span>
  </div>
</template>

<script>
import EditorView from '@/views/EditorView'
import QuestionnaireView from '@/views/QuestionnaireView'

import FSpinner from '@/components/questionnaires/Spinner.vue'

export default {
  name: 'editor-questionnaire-view',

  components: {
    EditorView,
    QuestionnaireView,

    FSpinner
  },

  created () {
    this.$store.dispatch('getAutofill', this.$store.state.currentFormId).then(response => {
      if (response.data.length > 0) {
        let autofillId = response.data[0]._id

        this.$store.dispatch('getAutofillDetails', autofillId).then(() => {
          this.$store.dispatch('getOfficialModel')
        })
      } else {
        this.$store.commit('setAutofillDetails', [])
        this.$store.commit('setOfficialModels', [])
      }
    })
  }
}
</script>

<style lang="scss" scoped>
  .master{
      height: 100%;
      width: 50%;
      position: absolute;
      left: 0;
      overflow-y: scroll;
  }
  .master2{
      height: 89.5%;
      width: 50%;
      left: 50%;
      position: absolute;
      overflow-y: scroll;
      bottom: 0;
      // box-shadow: 5px 4px 9px -3px rgba(0,0,0,0.8);
  }

  #benchView, #questionnaireView {
    position: absolute;
    // top: 23%;
    bottom: 0;
    overflow-x: auto;
  }


  #benchView {
    position: absolute;
    left: 0;
    width: 50%;
    overflow: scroll;
    border-right: 1px solid black;
    height: calc(100vh - 64px);
  }

  #questionnaireView {
    right: 0;
    width: 50%;
    height: calc(100vh - 50px);
  }
</style>





// WEBPACK FOOTER //
// src/views/EditorQuestionnaireView.vue